module.exports = __webpack_public_path__ + "static/img/idcard.a0ee1c3c.svg";